module.exports = "label {\n  line-height: 1rem;\n  display: table;\n  vertical-align: middle;\n  font-weight: bold; }\n\n.labelText {\n  padding: 0 0.5rem;\n  display: table-cell;\n  vertical-align: middle; }\n\ninput {\n  width: 1rem;\n  height: 1rem; }\n\n.btn {\n  margin: 0 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/content/my-offers/follow-up/follow-up.component.scss
// module id = ./src/app/content/my-offers/follow-up/follow-up.component.scss
// module chunks = main